import { IS_E2E } from '@/test-support/e2e-mode';

/**
 * Intercom messenger configuration, read from public Vite env (the app id is a
 * public workspace identifier — same class as the LaunchDarkly client id and
 * Segment write key, so it lives in the browser env, not the api). The
 * Identity-Verification `user_hash` is the only secret-derived value and comes
 * from `GET /intercom/identity`, never from env.
 */

/** Public Intercom workspace id. Empty disables the messenger (local dev / E2E). */
export const INTERCOM_APP_ID = (import.meta.env.VITE_INTERCOM_APP_ID ?? '') as string;

/** Optional workspace data region (`us` | `eu` | `ap`). Empty ⇒ Intercom's default (US). */
export const INTERCOM_REGION = (import.meta.env.VITE_INTERCOM_REGION ?? '') as string;

/**
 * The messenger is active only when an app id is configured and we're not under
 * Playwright (mirrors how analytics destinations are env-gated and skipped in
 * E2E so no third-party script loads during smoke tests).
 */
export function isIntercomEnabled(): boolean {
  return Boolean(INTERCOM_APP_ID) && !IS_E2E;
}
